<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Update Container Load Status</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave" v-if="dataForm">
          <md-field>
            <label>Load Key</label>
            <md-input v-model="dataForm.seqNo" disabled/>
          </md-field>

          <md-field>
            <label>Container No</label>
            <md-input v-model="dataForm.containerNo" disabled/>
          </md-field>

          <md-field>
            <label>Chassis No</label>
            <md-input v-model="dataForm.chassisNo" disabled/>
          </md-field>

          <md-field>
            <label>Seal No</label>
            <md-input v-model="dataForm.sealNumber" disabled/>
          </md-field>
          <auto-complete-master-data-select
                       label="Load Status"
                       :prepared-options="this.statusList"
                       :init-value-id="dataForm.loadStatus"
                       :on-item-changed="handleLoadStatusChanged">
          </auto-complete-master-data-select>
           
          <calling-api type="bar" path="/api/w/ccic/container/update">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    seqNo: null,
    containerNo: null,
    chassisNo: null,
    sealNumber: null,
    loadStatus: null,
  });

  const getInitialReq = () => ({
    seqNo: null,
    containerNo: null,
    chassisNo: null,
    appointment: null,
    apptDate: null,
    apptTime: null,
    dispatcherInstruction: null,
    pushStatus: null,
    driverGroup: null,
    driverId: null,
    loadStatus: null,
  });

  const getInitialStatusList = () => ({
     tagId: null,
     tagName: null,
     id: null,
     name: null,
  });

  export default {
    components: {},
    mixins: [validationMixin],
    props: { action: Function},
    data: () => ({
      showDialog: false,
      dataForm: getInitialDataForm(),
      reqForm: getInitialReq(),
      tempStatusList: getInitialStatusList(),
      reqs: [],
      items: [],
      statusList: [],
      mastergroups: [],
      browsername: null, 
    }),
    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getUserProfile',
      ]),
      getPickupLocationOptions() {
        const { ccicSupplierGroup } = this.getUserProfile;
        if (ccicSupplierGroup) {
          return this.getMasterDataAsSelectOptionByGroup(ccicSupplierGroup);
        }
        return [];
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          this.$store.commit('clearApiError');
        }
      },
    },
    methods: {
      async openDialog(container) {
        //this.dataForm = JSON.parse(JSON.stringify(container));
        this.dataForm.seqNo = container.seqNo;
        this.dataForm.containerNo = container.containerNo;
        this.dataForm.chassisNo = container.chassisNo;
        this.dataForm.sealNumber = container.sealNumber;
        this.dataForm.loadStatus = container.loadStatus;
        this.reqForm.seqNo = container.seqNo;
        this.reqForm.containerNo = container.containerNo;
        this.reqForm.chassisNo = container.chassisNo;
        this.reqForm.appointment = container.appointment;
        this.reqForm.apptDate = container.apptDate;
        this.reqForm.apptTime = container.apptTime;
        this.reqForm.dispatcherInstruction = container.dispatcherInstruction;
        this.reqForm.pushStatus = container.pushStatus;
        this.reqForm.driverGroup = container.driverGroup;
        this.reqForm.driverId = container.driverId;
        this.reqForm.loadStatus = container.loadStatus;
        this.mastergroups.push("GST_LOAD_STATUS");
        
        //console.log("browser version: " + navigator.userAgent);
        const browserversion = navigator.userAgent;
        this.browsername = browserversion.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        //console.log("browsername: " + this.browsername[1]);
        this.items = this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS');
        //reload the load status from db
        if (this.items == null || this.items.length == 0) {
           console.log("getting load status from db");
           //await api.post('/api/w/masterData',
           await newAPIPost('/api/w/masterData',
             {groups: this.mastergroups}).then ( (res) => {
                this.getLoadStatusWithFilter(res);
           })
        } else {
          this.getLoadStatusWithFilter(this.items); 
        }
        //console.log("statusList: " + JSON.stringify(this.statusList));
        this.showDialog = true;
      },
      handleLoadStatusChanged(id) {
         this.dataForm.loadStatus = this.getContentFromBrace(id);
      },
      getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
      },
      doSave() {
        if (this.dataForm.loadStatus == null || this.dataForm.loadStatus == "")
        {
            alert("Unable to save: Load Status is empty!!");
            return;
        }   
        this.reqForm.loadStatus = this.getContentFromBrace(this.dataForm.loadStatus);
        console.log("dataForm: " + JSON.stringify(this.dataForm));
        console.log("reqForm: " + JSON.stringify(this.reqForm));
        this.reqs.push(this.reqForm);
        this.showDialog = false;
        this.action(this.getContentFromBrace(this.dataForm.loadStatus));
        //api.post("/api/w/gst/updateyardstage", this.reqs)
        newAPIPost("/api/w/gst/updateyardstage", this.reqs)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action(this.dataForm.loadStatus)
            $('.btn-search-ccic-container')
              .click();
          });
      },
      getLoadStatusWithFilter(items) {
        if (items && items.length > 0) {
           var itemscount = items.length;
           this.statusList = [];
           while (itemscount > 0) {
              var item = items.pop();
              var tempItem = [];
              //console.log("item: " + JSON.stringify(item));
              if (item.tagId != "CFM" && item.tagId != "LOK" && item.tagId != "BLC") {
                 this.tempStatusList = getInitialStatusList();
                 this.tempStatusList.tagId = item.tagId;
                 this.tempStatusList.tagName = item.tagName;
                 this.tempStatusList.id = item.tagId;
                 this.tempStatusList.name = item.tagName;
                 this.statusList.push(this.tempStatusList);
              }
              itemscount -= 1;
           }
           //console.log("browsername in cap: " + this.browsername[1].toString().toUpperCase());
           if (this.browsername[1].toString().toUpperCase() == "CHROME") {
             //this.statusList = this.statusList.sort((a,b) => a.tagId - b.tagId);
             this.statusList = this.statusList.sort(function(a,b) {
                return a < b? 1 : -1;
             }
             )
           }  
           else 
             this.statusList = this.statusList.sort((a,b) => a.tagId > b.tagId);
         }    
      },
    },
  };


</script>
